// 쪽 그림 위에서 푸는 섹션(리더스북 전자책)인가. 이 섹션은 바깥 머리줄을 걷고 화면 전체를 책에 준다.
// 노트북에서 머리줄 · 좁은 본문 폭 때문에 쪽이 너무 작았다(2026-10-18 대표). 나가기는 책 안에 있다.
// 원서 · 내용이해 워크북은 쪽 그림이 아니라 지인에듀가 주는 글로 그린다(BookWorkbookPage, 10/18 대표).
export const isBookScreenSection = (section) => Boolean(section) && section.type === "ebook";

// 지인에듀가 파닉스북 이름을 'Ginedu Phonics · Unit 01 · …' 로 준다. 우리 교재 이름은 ECHO Phonics 다(2026-10-20 대표).
// 새 과제는 서버가 출제 때 바꿔 저장하고, 예전 과제는 화면에서 바꿔 보인다.
export const bookTitleOf = (title) => String(title || "").replace(/Ginedu Phonics/g, "ECHO Phonics");
